const carouselItems = [
  {
    title: '韩漫恋爱特辑：心动瞬间合集',
    desc: '从契约婚姻到命中注定，十部必追韩漫恋爱神作大盘点。高甜剧情、唯美画风，每一部都值得反复阅读。',
    image: 'https://readdy.ai/api/search-image?query=Korean%20romance%20webtoon%20featured%20banner%20style%2C%20beautiful%20couple%20illustration%20in%20romantic%20scene%2C%20soft%20pink%20and%20coral%20color%20palette%2C%20dreamy%20cherry%20blossom%20atmosphere%2C%20editorial%20banner%20design%2C%20warm%20and%20inviting%20composition%2C%20clean%20modern%20aesthetic&width=900&height=500&seq=qinqin-carousel-01&orientation=landscape',
    tag: '韩漫专区',
    color: 'from-primary-500/20 to-primary-100/80',
  },
  {
    title: '日漫热血榜：少年与剑的奇幻冒险',
    desc: '穿越异世界、剑与魔法的史诗战斗。日漫热血漫画精选推荐，热血沸腾的冒险故事永不落幕。',
    image: 'https://readdy.ai/api/search-image?query=Japanese%20action%20adventure%20manga%20featured%20banner%2C%20dynamic%20warrior%20character%20with%20sword%20in%20epic%20fantasy%20landscape%2C%20bold%20red%20and%20golden%20color%20scheme%2C%20dramatic%20composition%2C%20editorial%20banner%20design%2C%20powerful%20energy%2C%20clean%20modern%20aesthetic&width=900&height=500&seq=qinqin-carousel-02&orientation=landscape',
    tag: '日漫专区',
    color: 'from-accent-500/20 to-accent-100/80',
  },
  {
    title: '国漫新势力：东方奇幻美学盛宴',
    desc: '修仙、古风、神话新编——国漫正在用独特的东方美学征服读者。精选当下最热国漫，感受水墨丹青中的奇幻世界。',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20cultivation%20fantasy%20featured%20banner%2C%20ethereal%20immortal%20characters%20in%20traditional%20flowing%20robes%20among%20misty%20mountains%2C%20soft%20jade%20green%20and%20golden%20color%20palette%2C%20ink%20painting%20aesthetic%20with%20modern%20digital%20art%2C%20editorial%20banner%20design%2C%20clean%20modern%20aesthetic&width=900&height=500&seq=qinqin-carousel-03&orientation=landscape',
    tag: '国漫专区',
    color: 'from-secondary-500/20 to-secondary-100/80',
  },
  {
    title: '新作速递：本周上架漫画一览',
    desc: '亲亲漫画本周上架多部热门新作，涵盖恋爱、奇幻、悬疑等多种题材。下拉式阅读，免费全集在线，立即开启追漫之旅。',
    image: 'https://readdy.ai/api/search-image?query=New%20manga%20releases%20featured%20banner%2C%20colorful%20manga%20book%20covers%20floating%20in%20warm%20ambient%20light%2C%20Korean%20Japanese%20Chinese%20comic%20art%20styles%20blend%2C%20fresh%20and%20inviting%20atmosphere%2C%20editorial%20banner%20design%2C%20clean%20modern%20aesthetic%2C%20soft%20gradient%20background&width=900&height=500&seq=qinqin-carousel-04&orientation=landscape',
    tag: '新作速递',
    color: 'from-primary-500/20 to-accent-100/80',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-12 md:py-16 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 text-center mb-8">
          焦点专题
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6">
          {carouselItems.map((item) => (
            <a
              key={item.title}
              href="#"
              onClick={(e) => e.preventDefault()}
              className="group relative rounded-2xl overflow-hidden cursor-pointer"
            >
              <div className="aspect-[16/9] bg-secondary-100/50 overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  title={`亲亲漫画 ${item.tag} - ${item.title}`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  onError={(e) => {
                    const target = e.currentTarget;
                    target.style.display = 'none';
                  }}
                />
              </div>
              <div className={`absolute inset-0 bg-gradient-to-t ${item.color} via-transparent to-transparent`}></div>
              <div className="absolute bottom-0 left-0 right-0 p-5 md:p-6">
                <span className="inline-block px-3 py-1 bg-background-50/90 backdrop-blur-sm rounded-full text-xs font-medium text-foreground-800 mb-3">
                  {item.tag}
                </span>
                <h3 className="text-base md:text-lg font-heading font-bold text-background-50 drop-shadow-md">
                  {item.title}
                </h3>
                <p className="mt-2 text-xs md:text-sm text-background-100/90 leading-relaxed line-clamp-2 max-w-md drop-shadow-sm">
                  {item.desc}
                </p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}